<template>
  <button class="custom-btn btn-10">
    <slot/>
  </button>
</template>

<script>
export default {
  name: "Bt400",
  props: {
    href: {
      type: String,
      default: "https://mixitweb.com",
    }
  }
}
</script>

<style scoped>

.custom-btn {
  color: var(--light-white);
  padding: 8px;
  font-weight: 500;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: inline-block;
  border: 1px solid var(--primary) !important;
  outline: none;
  border-radius: 30px;
}

/* 10 */
.btn-10 {
  background: transparent;
  color: var(--primary);
  border: 2px soli var(--primary);
  transition: all 0.3s ease;
  overflow: hidden;


}

.btn-10:after {
  position: absolute;
  content: " ";
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  transition: all 0.3s ease;
  -webkit-transform: scale(.1);
  transform: scale(.1);
}

.btn-10:hover {
  color: var(--light-white);
  border: none;
  background: transparent;
}

.btn-10:hover:after {
  background: var(--light-teal);
  -webkit-transform: scale(1);
  transform: scale(-1);
  border-radius: 30px !important;
}

</style>